import { atom } from "recoil";
import View from "../enums/View";

const viewState = atom<View>({
  key: "viewState",
  default: View.init,
});

export default viewState;
